import { Card, Row, Col, Button } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getPhoto } from '../utils/ComponentUtils';
import LeagueSocial from './LeagueSocial';

function LeagueCard(props) {
    const { t } = useTranslation();

    if (props.selectedLeague == null) {
        return (
            <Card className="league-card-grid">
                <div>
                  <h2>Select a League</h2>
                  <p>Click on a marker to see league details.</p>
                </div>
            </Card>  
        );
    }

    if (props.selectedLeague.imageUrl == '') {
        return(
            <Card className="league-card-grid">
                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <h2>{props.selectedLeague.leagueName}</h2>
                        <p>{t('leagues.social')}: <LeagueSocial social ={props.selectedLeague.facebookUrl} size="small"/><br/>
                        {t('leagues.status')}: {props.selectedLeague.status ? t('leagues.active') : t('leagues.inactive')}</p>
                        <Link to={`/leagues/${props.selectedLeague.id}`}>
                            <Button type="primary" style={{ marginTop: '10px' }}>
                            {t('leagues.view')}
                            </Button>
                        </Link>
                    </Col>
                </Row>
            </Card>  
        );
    }

    return (
        <Card className="league-card-grid" >
              {props.selectedLeague != null &&
                <Row style={{ alignItems: 'center' }}>
                    <Col xs={24} sm={24} md={24} lg={9} xl={9}>
                        <img src={getPhoto(props.selectedLeague.imageUrl)} alt="League Logo" style={{ maxHeight: '20vh', maxWidth: '200px' }} />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={15} xl={15}>
                        <h2>{props.selectedLeague.leagueName}</h2>
                        <p>{t('leagues.social')}: <LeagueSocial social ={props.selectedLeague.facebookUrl} size="small" /><br/>
                        {t('leagues.status')}: {props.selectedLeague.status ? t('leagues.active') : t('leagues.inactive')}</p>
                        <Link to={`/leagues/${props.selectedLeague.id}`}>
                            <Button type="primary" style={{ marginTop: '10px' }}>
                            {t('leagues.view')}
                            </Button>
                        </Link>
                    </Col>
                </Row>
              }
            </Card>  
    )
}

export default LeagueCard;